











































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import { commitAddNotification } from '@/store/main/mutations';

@Component
export default class CustomerDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;

  public async customSave(rec, apiUrl) {
    const ref: any = this.$refs.layout;
    if (!rec.is_multi_contact) {
      // Fill in name and title of single contact
      rec.contacts[0].name = rec.name;
      rec.contacts[0].title = rec.title;
    }
    ref.commitRecord(rec);
  }
}
